import { motion } from "framer-motion";
import { HE } from "@/lib/i18n";
import { t } from "@/lib/strings";

const ratingColor = (rating) =>
  rating === "High" ? "#00C853" : rating === "Medium" ? "#FFB300" : "#FF1744";

const ratingLabel = (rating) =>
  HE
    ? rating === "High"
      ? t("gauge.high")
      : rating === "Medium"
        ? t("gauge.medium")
        : t("gauge.low")
    : `${rating} Visibility`;

export const ScoreGauge = ({ score = 0, rating = "Low", size = 240 }) => {
  const stroke = 16;
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const arcFraction = 0.75; // 270deg sweep
  const dash = circ * arcFraction;
  const progress = dash * (Math.min(100, Math.max(0, score)) / 100);
  const color = ratingColor(rating);

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }} data-testid="score-gauge">
      <svg width={size} height={size} className="-rotate-[135deg]">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(10,10,10,0.08)"
          strokeWidth={stroke}
          strokeDasharray={`${dash} ${circ}`}
          strokeLinecap="butt"
        />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="butt"
          strokeDasharray={`0 ${circ}`}
          initial={{ strokeDasharray: `0 ${circ}` }}
          animate={{ strokeDasharray: `${progress} ${circ}` }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <motion.span
          className="font-data font-bold tracking-tighter text-obsidian"
          style={{ fontSize: size * 0.28, lineHeight: 1 }}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          data-testid="score-value"
        >
          {score}
        </motion.span>
        <span className="av-label mt-1" dir="ltr">/ 100</span>
        <span
          className="mt-3 font-data text-xs font-bold uppercase tracking-[0.2em] px-3 py-1 border-2"
          style={{ color, borderColor: color }}
          data-testid="score-rating"
        >
          {ratingLabel(rating)}
        </span>
      </div>
    </div>
  );
};

export default ScoreGauge;
